const collator = new Intl.Collator('es', {
  sensitivity: 'base',
  numeric: true
});

export const sortCommunitiesByName = communities =>
  [...communities].sort((a, b) =>
    collator.compare(a?.name || '', b?.name || '')
  );

// Connectors that carry no identity in a community name ("Rincón de la Costa" -> "RC").
// A leading article is kept: it is part of the name ("El Nido" -> "EN", "La Horqueta" -> "LH").
const STOP_WORDS = ['de', 'del', 'la', 'las', 'el', 'los', 'y'];

// One letter per significant word, as written in the name ("Barrio Keen Ville" -> "BKV").
const MAX_INITIALS = 3;

export const getCommunityInitials = name => {
  // words that start with a letter or digit only: "&", "-" and the like are not initials
  const words = (name || '')
    .trim()
    .split(/\s+/)
    .filter(w => /^[\p{L}\p{N}]/u.test(w));
  const significant = words.filter(
    (w, index) => index === 0 || !STOP_WORDS.includes(w.toLowerCase())
  );
  const source = significant.length ? significant : words;
  if (!source.length) {
    return '?';
  }
  return source
    .slice(0, MAX_INITIALS)
    .map(word => word[0])
    .join('')
    .toUpperCase();
};
